import { TypographyColor } from 'melp-design/components';
import { FeedbackStatus } from './feedback.types';

export const COLOR_BY_STATUS: Record<FeedbackStatus, TypographyColor> = {
  pending: 'warning',
  in_progress: 'primary',
  resolved: 'success',
  closed: 'error',
};
